import React from 'react';
import ReactModal from 'react-modal';

// This is a wrapper around ReactModal to provide a consistent interface
const ModalWrapper = ({ children, isOpen, onRequestClose, className, overlayClassName, ...props }) => {
    // Initialize ReactModal
    React.useEffect(() => {
        // Set app element for accessibility
        if (typeof window !== 'undefined' && document.getElementById('root')) {
            ReactModal.setAppElement('#root');
        }
    }, []);

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            className={className || 'modal-content'}
            overlayClassName={overlayClassName || 'modal-overlay'}
            {...props}
        >
            {children}
        </ReactModal>
    );
};

export default ModalWrapper; 